import React from 'react';
import styled from 'styled-components';
import SubLayout from '../components/layout/SubLayout';
import { businessMenus } from '../data/businessMenus';

const Intro = styled.p`
  font-size: 1.05rem;
  color: #555;
  line-height: 1.9;
  margin-bottom: 50px;
`;

const ServiceGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 20px;
  margin-bottom: 50px;
`;

const ServiceCard = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 30px 25px;
  background: #fff;
  transition: box-shadow 0.2s ease, border-color 0.2s ease;

  &:hover {
    box-shadow: 0 6px 20px rgba(0, 86, 179, 0.1);
    border-color: #0056b3;
  }

  .icon { font-size: 2rem; margin-bottom: 12px; }
  h4 { font-size: 1.1rem; color: #222; margin-bottom: 8px; }
  p { font-size: 0.9rem; color: #666; line-height: 1.7; }
`;

const SectionLabel = styled.h3`
  font-size: 1.3rem;
  color: #1a2a40;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #e0e0e0;
`;

const FeatureBox = styled.div`
  background: #f8f9fa;
  border-left: 4px solid #0056b3;
  padding: 20px 25px;
  border-radius: 0 8px 8px 0;
  margin-bottom: 15px;

  h4 { font-size: 1rem; color: #333; margin-bottom: 6px; }
  p { font-size: 0.9rem; color: #666; line-height: 1.6; }
`;

const BusinessPavement = () => {
  return (
    <SubLayout
      title="지반조성·포장공사"
      sidebarMenus={businessMenus}
      category="사업영역"
      categoryEn="Business"
      bannerBg="/images/bg_landscape.jpg"
    >
      <Intro>
        주식회사 두성시스템은 지반조성·포장공사업 면허를 바탕으로,
        <strong> 포장공사를 주력분야</strong>로 수행합니다.
        정밀한 다짐과 포장 기술로 평탄하고 내구성 높은 도로 및 부지를 조성합니다.
      </Intro>

      <SectionLabel>주요 서비스</SectionLabel>
      <ServiceGrid>
        <ServiceCard>
          <div className="icon">🛣️</div>
          <h4>아스팔트 포장</h4>
          <p>도로·주차장 등 아스팔트 포장 공사로 평탄하고 견고한 노면을 조성합니다.</p>
        </ServiceCard>
        <ServiceCard>
          <div className="icon">🧱</div>
          <h4>콘크리트 포장</h4>
          <p>내하중이 요구되는 구간에 대한 콘크리트 포장 공사를 전문 수행합니다.</p>
        </ServiceCard>
        <ServiceCard>
          <div className="icon">🚜</div>
          <h4>지반 조성·정지</h4>
          <p>부지 정리 및 지반 조성·정지 작업으로 안정적인 시공 기반을 마련합니다.</p>
        </ServiceCard>
        <ServiceCard>
          <div className="icon">⛰️</div>
          <h4>성토·절토·부지정리</h4>
          <p>성토·절토 및 부지 정리를 통해 계획 고에 맞는 지형을 조성합니다.</p>
        </ServiceCard>
      </ServiceGrid>

      <SectionLabel>특장점</SectionLabel>
      <FeatureBox>
        <h4>포장공사 전문 시공</h4>
        <p>주력분야인 포장공사에서 다짐 관리와 품질 시험을 통해 균열 없는 포장을 완성합니다.</p>
      </FeatureBox>
      <FeatureBox>
        <h4>체계적인 지반 관리</h4>
        <p>지반 조성 단계부터 철저한 다짐 관리로 침하 없는 견고한 기반을 확보합니다.</p>
      </FeatureBox>
      <FeatureBox>
        <h4>중장비 운용 역량</h4>
        <p>포장·토공 장비의 효율적 운용으로 정확하고 신속한 시공을 실현합니다.</p>
      </FeatureBox>
    </SubLayout>
  );
};

export default BusinessPavement;
